import { render, staticRenderFns } from "./MantenedorCoordinadorBase.vue?vue&type=template&id=02d450cc&"
import script from "./MantenedorCoordinadorBase.vue?vue&type=script&lang=ts&"
export * from "./MantenedorCoordinadorBase.vue?vue&type=script&lang=ts&"
import style0 from "./MantenedorCoordinadorBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('02d450cc', component.options)
    } else {
      api.reload('02d450cc', component.options)
    }
    module.hot.accept("./MantenedorCoordinadorBase.vue?vue&type=template&id=02d450cc&", function () {
      api.rerender('02d450cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorCoordinador/MantenedorCoordinadorBase.vue"
export default component.exports